import contactPointsSowosModerateFundTypes from './sowos-moderate/types';

export default {
  ...contactPointsSowosModerateFundTypes,
};
